import { h } from 'vue';

const iconNames = [
  'arrow-clockwise', 'arrow-repeat', 'backspace', 'bar-chart-fill',
  'box-arrow-in-right', 'check', 'check-circle', 'chevron-down', 'chevron-up', 'circle-fill', 'dash-circle-fill',
  'download', 'envelope', 'exclamation-circle-fill', 'exclamation-triangle-fill',
  'hdd-network', 'lock', 'lock-fill', 'pen', 'pencil', 'plus', 'server', 'three-dots', 'trash', 'unlock'
];

export const iconsPlugin = {
  install(app) {
    // <b-icon icon="name"> support
    app.component('BIcon', {
      props: ['icon'],
      render() {
        return h('i', { class: `bi bi-${this.icon}` });
      }
    });

    // <b-icon-name> support
    iconNames.forEach(name => {
      const componentName = 'BIcon' + name
        .split('-')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join('');
      app.component(componentName, {
        render() {
          return h('i', { class: `bi bi-${name}` });
        }
      });
    });
  }
};
